import Vue from "vue";
import VueRouter from "vue-router";
import PageNotFound from "./pages/PageNotFound.vue";
import Home from "./pages/Home.vue";
import ProductListPage from "./pages/ProductListPage.vue";
import NewArrivals from "./pages/NewArrivals.vue";
import Sale from "./pages/Sale.vue";
import Recommend from "./pages/Recommend.vue";
import Cart from "./pages/Cart.vue";
import Profile from "./pages/Profile.vue";
import Orders from "./pages/Orders.vue";
import SellOffers from "./pages/SellOffers.vue";
import PaymentSuccessPage from "./pages/PaymentSuccessPage.vue";
import PaymentFaliPage from "./pages/PaymentFaliPage.vue";
import TextPage from "./pages/TextPage.vue";
import Login from "./pages/Login.vue";
import Registration from "./pages/Registration.vue";
import Recover from "./pages/Recover.vue";
import OfferSuccessPage from "./pages/OfferSuccessPage.vue";
import OfferAcceptedPage from "./pages/OfferAcceptedPage.vue";
import PayoutResultPage from "./pages/PayoutResultPage.vue";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  routes: [
    { path: "/", redirect: "/home" },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/recover",
      name: "Recover",
      component: Recover,
    },
    {
      path: "/registration",
      name: "Registration",
      component: Registration,
    },
    {
      path: "/product-list/:id",
      name: "ProductListPage",
      component: ProductListPage,
    },
    {
      path: "/product/:slug",
      beforeEnter(to, from, next) {
        try {
          const slug = to.params.slug || "";
          const m = slug.match(/(\d+)$/);
          const id = m ? m[1] : null;
          console.log('Redirecting to product list with id:', id);  
          if (id) {
            next({ path: "/product-list/all", query: { productId: id } });
          } else {
            next({ path: "/product-list/all" });
          }
        } catch (e) {
          next({ path: "/product-list/all" });
        }
      },
    },
    {
      path: "/fresh",
      name: "NewArrivals",
      component: NewArrivals,
    },
    {
      path: "/sale",
      name: "Sale",
      component: Sale,
    },
    {
      path: "/recommend",
      name: "Recommend",
      component: Recommend,
    },
    {
      path: "/cart",
      name: "Cart",
      component: Cart,
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
    },
    {
      path: "/orders",
      name: "Orders",
      component: Orders,
    },
    {
      path: "/offers",
      name: "SellOffers",
      component: SellOffers,
    },
    {
      path: "/success-payment",
      name: "PaymentSuccessPage",
      component: PaymentSuccessPage,
    },
    {
      path: "/fail-payment",
      name: "PaymentFaliPage",
      component: PaymentFaliPage,
    },

    {
      path: "/offer-sent-succes",
      name: "OfferSuccessPage",
      component: OfferSuccessPage,
    },

    {
      path: "/offer-accepted-succes",
      name: "OfferAcceptedPage",
      component: OfferAcceptedPage,
    },
    {
      path: "/success-payout",
      name: "PayoutSuccess",
      component: PayoutResultPage,
      props: { status: "success" },
    },
    {
      path: "/fail-payout",
      name: "PayoutFailure",
      component: PayoutResultPage,
      props: { status: "failure" },
    },
    {
      path: "/pending-payout",
      name: "PayoutStatus",
      component: PayoutResultPage,
      props: (route) => ({
        status: route.query.status || "failure",
        message: route.query.message || "",
      }),
    },
    {
      path: "/:identifier",
      name: "TextPage",
      component: TextPage,
    },
    {
      path: "*",
      name: "PageNotFound",
      component: PageNotFound,
      props: { title: "PageNotFound" },
    },
  ],
});
